const pickerSelector = '[data-kh-size-picker]';
const pickerUpdates = new WeakMap();
const mobileSizeLayout = window.matchMedia('(max-width: 768px)');
function initializeSizePicker(root) {
  if (!root) return;
  if (pickerUpdates.has(root)) {
    return;
  }
  const mapElement = root.querySelector('[data-kh-size-map]');
  if (!mapElement) return;
  let rawSizeMap = {};
  try {
    rawSizeMap = JSON.parse(
      mapElement.textContent.trim()
    );
    if (typeof rawSizeMap === 'string') {
      try {
        rawSizeMap = JSON.parse(rawSizeMap);
      } catch (e) {}
    }
  } catch (error) {
    console.warn(
      'KONHILL size converter: Invalid size_conversion_data.',
      error
    );
    return;
  }
  if (
    !rawSizeMap ||
    typeof rawSizeMap !== 'object' ||
    Array.isArray(rawSizeMap)
  ) {
    return;
  }
  let standardSwitcher = root.querySelector('[data-size-standard-switcher]');
  if (!standardSwitcher) return;
  function positionStandardSwitcher() {
    const liveSwitcher = root.querySelector('[data-size-standard-switcher]');
    if (liveSwitcher) standardSwitcher = liveSwitcher;
    const mobileSlot = root.querySelector('[data-kh-size-switcher-slot]');
    const desktopSlot = root.querySelector('[data-kh-size-switcher-desktop]');
    const target = mobileSizeLayout.matches && mobileSlot ? mobileSlot : desktopSlot;
    if (target && standardSwitcher.parentElement !== target) {
      target.appendChild(standardSwitcher);
    }
    const standard = getCurrentStandard();
    standardSwitcher.querySelectorAll('.size-standard-btn').forEach((button) => {
      const active = button.dataset.standard === standard;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  }
  function normalizeSize(value) {
    if (
      value === undefined ||
      value === null
    ) {
      return '';
    }
    return String(value)
      .replace(/\bUS\b/gi, '')
      .replace(/\bUK\b/gi, '')
      .replace(/\bEU\b/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  }
  const sizeMap = {};
  Object.keys(rawSizeMap).forEach(function (rawKey) {
    const normalizedKey = normalizeSize(rawKey);
    if (!normalizedKey) return;
    const rawRow = rawSizeMap[rawKey];
    if (
      !rawRow ||
      typeof rawRow !== 'object'
    ) {
      return;
    }
    const row = {};
    Object.keys(rawRow).forEach(function (key) {
      const normalizedStandard =
        String(key).toLowerCase().trim();
      row[normalizedStandard] =
        normalizeSize(rawRow[key]);
    });
    sizeMap[normalizedKey] = row;
  });
  if (Object.keys(sizeMap).length === 0) {
    return;
  }
  const indexes = {
    key: {},
    us: {},
    uk: {},
    eu: {}
  };
  Object.keys(sizeMap).forEach(function (key) {
    const row = sizeMap[key];
    indexes.key[key] = row;
    ['us', 'uk', 'eu'].forEach(function (standard) {
      const size = normalizeSize(
        row[standard]
      );
      if (!size) return;
      indexes[standard][size] = row;
    });
  });
  function getCurrentStandard() {
    if (['us', 'uk', 'eu'].includes(root.dataset.khCurrentStandard)) {
      return root.dataset.khCurrentStandard;
    }
    const activeButton =
      root.querySelector('.size-standard-btn.active');
    if (
      activeButton &&
      activeButton.dataset.standard
    ) {
      return activeButton.dataset.standard;
    }
    return (
      root.dataset.defaultStandard ||
      'us'
    );
  }
  function hasSizeContext(element) {
    if (!element) return false;
    if (element.closest('[data-kh-size-option]')) return true;
    const strings = [
      element.name,
      element.id,
      element.dataset
        ? element.dataset.optionName
        : '',
      element.dataset
        ? element.dataset.name
        : ''
    ];
    for (const value of strings) {
      if (
        value &&
        /size/i.test(String(value))
      ) {
        return true;
      }
    }
    const group = element.closest(
      'fieldset, .variant-option, .product-form__input, .product-form__option, variant-selects, variant-radios'
    );
    if (group) {
      const heading = group.querySelector(
        'legend, .variant-option__label, .form__label, .product-form__label'
      );
      if (
        heading &&
        /size/i.test(heading.textContent)
      ) {
        return true;
      }
    }
    return false;
  }
  function isNumericSize(value) {
    const normalized =
      normalizeSize(value);
    return /^\d+(?:\.\d+)?$/.test(
      normalized
    );
  }
  function existsInAnyIndex(value) {
    const size =
      normalizeSize(value);
    if (!size) return false;
    return Boolean(
      indexes.key[size] ||
      indexes.us[size] ||
      indexes.uk[size] ||
      indexes.eu[size]
    );
  }
  function collectOriginalSizes() {
    const values = [];
    root
      .querySelectorAll('input[type="radio"]')
      .forEach(function (input) {
        const value =
          normalizeSize(input.value);
        if (!value) return;
        if (
          hasSizeContext(input) ||
          (
            isNumericSize(value) &&
            existsInAnyIndex(value)
          )
        ) {
          values.push(value);
        }
      });
    root
      .querySelectorAll('select')
      .forEach(function (select) {
        const selectIsSize =
          hasSizeContext(select);
        if (!selectIsSize) return;
        Array
          .from(select.options)
          .forEach(function (option) {
            const valueCandidate =
              normalizeSize(option.value);
            const textCandidate =
              normalizeSize(option.textContent);
            if (
              selectIsSize &&
              existsInAnyIndex(valueCandidate)
            ) {
              values.push(valueCandidate);
              return;
            }
            if (
              selectIsSize &&
              existsInAnyIndex(textCandidate)
            ) {
              values.push(textCandidate);
            }
          });
      });
    return values;
  }
  function detectSourceStandard() {
    const values =
      collectOriginalSizes();
    if (values.length === 0) {
      return 'key';
    }
    const scores = {
      key: 0,
      us: 0,
      uk: 0,
      eu: 0
    };
    values.forEach(function (value) {
      if (indexes.key[value]) {
        scores.key++;
      }
      if (indexes.us[value]) {
        scores.us++;
      }
      if (indexes.uk[value]) {
        scores.uk++;
      }
      if (indexes.eu[value]) {
        scores.eu++;
      }
    });
    const preference = [
      'key',
      'us',
      'uk',
      'eu'
    ];
    let winner = 'key';
    let highestScore = -1;
    preference.forEach(function (standard) {
      if (
        scores[standard] >
        highestScore
      ) {
        highestScore =
          scores[standard];
        winner =
          standard;
      }
    });
    return winner;
  }
  const sourceStandard =
    detectSourceStandard();
  root.dataset.khSourceStandard =
    sourceStandard;
  function getConversionRow(rawSize) {
    const size =
      normalizeSize(rawSize);
    if (!size) return null;
    const sourceIndex =
      indexes[sourceStandard];
    if (!sourceIndex) {
      return null;
    }
    return (
      sourceIndex[size] ||
      null
    );
  }
  function getDisplaySize(rawSize) {
    const normalizedRaw =
      normalizeSize(rawSize);
    const row =
      getConversionRow(normalizedRaw);
    if (!row) {
      return normalizedRaw;
    }
    const standard =
      getCurrentStandard();
    return (
      row[standard] ||
      normalizedRaw
    );
  }
  function findLabelForInput(input) {
    if (!input) return null;
    if (input.id) {
      const labels =
        root.querySelectorAll('label[for]');
      for (const label of labels) {
        if (
          label.getAttribute('for') ===
          input.id
        ) {
          return label;
        }
      }
    }
    return input.closest('label');
  }
  function setLabelDisplay(
    label,
    rawSize,
    displaySize
  ) {
    if (!label) return;
    const existing =
      label.querySelector(
        '[data-kh-size-text]'
      );
    if (existing) {
      if (
        existing.textContent !==
        displaySize
      ) {
        existing.textContent =
          displaySize;
      }
      existing.dataset.originalSize =
        rawSize;
      return;
    }
    let targetTextNode = null;
    for (
      const node of label.childNodes
    ) {
      if (
        node.nodeType === Node.TEXT_NODE &&
        node.textContent.trim() !== ''
      ) {
        targetTextNode = node;
        break;
      }
    }
    if (targetTextNode) {
      const span =
        document.createElement('span');
      span.setAttribute(
        'data-kh-size-text',
        ''
      );
      span.dataset.originalSize =
        rawSize;
      span.textContent =
        displaySize;
      targetTextNode.parentNode
        .replaceChild(
          span,
          targetTextNode
        );
      return;
    }
    const dedicatedText =
      label.querySelector(
        '.variant-option__button-label__text'
      );
    if (dedicatedText) {
      dedicatedText.textContent = '';
      const span =
        document.createElement('span');
      span.setAttribute(
        'data-kh-size-text',
        ''
      );
      span.dataset.originalSize =
        rawSize;
      span.textContent =
        displaySize;
      dedicatedText.appendChild(span);
      return;
    }
    const possibleSpans =
      label.querySelectorAll('span');
    for (const span of possibleSpans) {
      if (
        span.classList.contains(
          'visually-hidden'
        ) ||
        span.classList.contains(
          'sr-only'
        ) ||
        span.getAttribute(
          'aria-hidden'
        ) === 'true'
      ) {
        continue;
      }
      if (
        normalizeSize(span.textContent) ===
        rawSize
      ) {
        span.setAttribute(
          'data-kh-size-text',
          ''
        );
        span.dataset.originalSize =
          rawSize;
        span.textContent =
          displaySize;
        return;
      }
    }
  }
  function processRadioInputs() {
    root
      .querySelectorAll(
        'input[type="radio"]'
      )
      .forEach(function (input) {
        let rawSize =
          input.dataset.khOriginalSize;
        if (!rawSize) {
          rawSize =
            normalizeSize(input.value);
          if (
            !hasSizeContext(input) &&
            !(
              isNumericSize(rawSize) &&
              getConversionRow(rawSize)
            )
          ) {
            return;
          }
          if (
            !getConversionRow(rawSize)
          ) {
            return;
          }
          input.dataset.khOriginalSize =
            rawSize;
        }
        const row =
          getConversionRow(rawSize);
        if (!row) return;
        const displaySize =
          getDisplaySize(rawSize);
        const label =
          findLabelForInput(input);
        if (!label) return;
        setLabelDisplay(
          label,
          rawSize,
          displaySize
        );
      });
  }
  function processSelects() {
    root
      .querySelectorAll('select')
      .forEach(function (select) {
        const selectIsSize =
          hasSizeContext(select);
        if (!selectIsSize) return;
        Array
          .from(select.options)
          .forEach(function (option) {
            let rawSize =
              option.dataset.khOriginalSize;
            if (!rawSize) {
              const valueCandidate =
                normalizeSize(
                  option.value
                );
              const textCandidate =
                normalizeSize(
                  option.textContent
                );
              if (
                getConversionRow(
                  valueCandidate
                )
              ) {
                rawSize =
                  valueCandidate;
              }
              else if (
                selectIsSize &&
                getConversionRow(
                  textCandidate
                )
              ) {
                rawSize =
                  textCandidate;
              }
              else {
                return;
              }
              option.dataset.khOriginalSize =
                rawSize;
            }
            const displaySize =
              getDisplaySize(rawSize);
            if (
              option.textContent !==
              displaySize
            ) {
              option.textContent =
                displaySize;
            }
          });
      });
  }
  let observer = null;
  let scheduled = false;
  function startObserver() {
    if (!observer) return;
    observer.observe(
      root,
      {
        childList: true,
        subtree: true
      }
    );
  }
  function processAll() {
    scheduled = false;
    if (!root.isConnected) {
      observer?.disconnect();
      return;
    }
    if (observer) {
      observer.disconnect();
    }
    positionStandardSwitcher();
    processRadioInputs();
    processSelects();
    startObserver();
  }
  function scheduleProcess() {
    if (scheduled || !root.isConnected) return;
    scheduled = true;
    requestAnimationFrame(
      processAll
    );
  }
  root.addEventListener(
    'click',
    function (event) {
      const button =
        event.target.closest(
          '.size-standard-btn'
        );
      if (!button) return;
      if (!root.contains(button)) {
        return;
      }
      event.preventDefault();
      const standard =
        button.dataset.standard;
      if (
        !['us', 'uk', 'eu'].includes(
          standard
        )
      ) {
        return;
      }
      root.dataset.khCurrentStandard = standard;
      root
        .querySelectorAll(
          '.size-standard-btn'
        )
        .forEach(function (item) {
          item.classList.toggle(
            'active',
            item.dataset.standard === standard
          );
        });
      processAll();
    }
  );
  root.addEventListener(
    'change',
    function () {
      scheduleProcess();
    }
  );
  observer =
    new MutationObserver(
      function () {
        scheduleProcess();
      }
    );
  processAll();
  root.addEventListener('variant:change', scheduleProcess);
  root.addEventListener('variant:update', scheduleProcess);
  pickerUpdates.set(root, scheduleProcess);
  root.dataset.khSizeSwitcherInitialized = 'true';
}
function discoverSizePickers(root) {
  if (!(root instanceof Element)) return;
  if (root.matches(pickerSelector)) initializeSizePicker(root);
  root.querySelectorAll(pickerSelector).forEach(initializeSizePicker);
}
discoverSizePickers(document.body);
const pickerDiscoveryObserver = new MutationObserver((mutations) => {
  const added = new Set();
  mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
    if (node instanceof Element && node.isConnected &&
        !node.parentElement?.closest(pickerSelector)) added.add(node);
  }));
  added.forEach((node) => {
    if (![...added].some((parent) => parent !== node && parent.contains(node))) {
      discoverSizePickers(node);
    }
  });
});
pickerDiscoveryObserver.observe(document.body, { childList: true, subtree: true });
for (const eventName of ['shopify:section:load', 'quickview:loaded', 'variant:update', 'variant:change']) {
  document.addEventListener(eventName, (event) => {
    const root = event.target instanceof Element ? event.target : document.body;
    discoverSizePickers(root);
    if (root !== document.body) {
      const picker = root.closest(pickerSelector);
      if (picker) pickerUpdates.get(picker)?.();
    }
  });
}
mobileSizeLayout.addEventListener('change', () => {
  document.querySelectorAll(pickerSelector).forEach((root) => {
    pickerUpdates.get(root)?.();
  });
});
